/* eslint-disable import/prefer-default-export */
export const RS_COLOR = [
  '#B5CA7D', '#b53d54', '#3d71b5',
];
